import { render, staticRenderFns } from "./Send.vue?vue&type=template&id=7b25fa8b&scoped=true"
import script from "./Send.vue?vue&type=script&lang=js"
export * from "./Send.vue?vue&type=script&lang=js"
import style0 from "./Send.vue?vue&type=style&index=0&id=7b25fa8b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b25fa8b",
  null
  
)

export default component.exports